import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import SinglePharmacy from './components/Single-pharmacy';
import Svgs from '../Common/Svgs';
import { getPharmacyListFilter } from '../Pharmacies/epics-pharmacies';

import localStorage from '../Common/LocalStorage';
import LocalizedStrings from 'react-localization';
import { translations } from '../Common/Translations';

let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang'));

const header = [
    { name: strings.Pharmacy_name, value: 'name' },
    {},
    { name: strings.City, value: 'city' },
    {},
    { name: strings.address, value: 'addressName' },
    {},
    { name: strings.employees, value: 'employees' },
    {},
    { name: strings.Email, value: 'email' },
    {},
    { name: strings.phone, value: 'phone' },
    {},
    { name: strings.Orders, value: 'orderCount' }
];

class Pharmacies extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderBy: 'name',
            orderDirection: 'asc',
            page: 0,
            limit: 30,
            pharmaciesList: [],
            pharmaciesCount: '',
            loadingSpinner: false
        };
    }

    generatePharmaciesList = ({ orderBy, orderDirection, page, limit }) => {
        this.setState({ ...this.state, loadingSpinner: true });

        let data = {
            offset: limit * page,
            limit: limit,
            sortBy: orderBy + '.' + orderDirection
        };

        getPharmacyListFilter(data)
            .then(res => {
                this.setState({
                    ...this.state,
                    pharmaciesList: res.pharmacies,
                    pharmaciesCount: res.count,
                    loadingSpinner: false
                });
            })
            .catch(() => {
                this.setState({
                    ...this.state,
                    pharmaciesList: [],
                    pharmaciesCount: '',
                    loadingSpinner: false
                });
            });
    };

    changeOrderBy = field => {
        if (this.state.orderBy === field && this.state.orderDirection === 'asc') {
            this.setState({
                ...this.state,
                orderDirection: 'desc',
                page: 0
            });
        } else {
            this.setState({
                ...this.state,
                orderBy: field,
                orderDirection: 'asc',
                page: 0
            });
        }
    };

    setPageNumber = pageNumber => {
        this.setState({ ...this.state, page: pageNumber });
    };

    onLimitChange = event => {
        this.setState({ ...this.state, limit: event.target.value, page: 0 });
    };

    generateTableHead = () => {
        let className = 'fa ';
        if (this.state.orderDirection === 'asc') {
            className += 'fa-angle-down';
        } else {
            className += 'fa-angle-up';
        }

        return (
            <thead>
                <tr>
                    {header.map((value, index) => {
                        if (value.name !== undefined) {
                            return (
                                <td key={index}>
                                    <div onClick={() => this.changeOrderBy(value.value)}>
                                        {value.name}
                                        {this.state.orderBy === value.value ? (
                                            <i className={className} />
                                        ) : (
                                            <i className={'qf-invisible ' + className} />
                                        )}
                                    </div>
                                </td>
                            );
                        } else {
                            return <td key={index} />;
                        }
                    })}
                    <td className="qf-action" />
                </tr>
            </thead>
        );
    };

    generateTableBody = () => {
        return (
            <tbody>
                {this.state.loadingSpinner ? (
                    <tr>
                        <td colSpan={11} className="text-center p-3">
                            <i className="fa fa-spinner fa-spin fa-3x" />
                        </td>
                    </tr>
                ) : (
                    (this.state.pharmaciesList || []).map(pharmacy => {
                        return (
                            <SinglePharmacy
                                id={pharmacy.id}
                                key={pharmacy.id}
                                name={pharmacy.name}
                                city={pharmacy.city}
                                addressName={pharmacy.addressName}
                                employees={pharmacy.employees}
                                email={pharmacy.email}
                                phone={pharmacy.phone}
                                orderCount={pharmacy.orderCount}
                            />
                        );
                    })
                )}
            </tbody>
        );
    };

    generatePagination = () => {
        if (
            this.state.pharmaciesCount !== undefined &&
            this.state.pharmaciesList !== undefined &&
            this.state.pharmaciesCount > this.state.pharmaciesList.length
        ) {
            let pagesArr = Array.apply(null, { length: Math.ceil(this.state.pharmaciesCount / parseInt(this.state.limit, 10)) }).map(
                Number.call,
                Number
            );
            return (
                <div className="row">
                    <div className="col qf-mb-30 text-center">
                        <nav aria-label="navigation">
                            <ul className="pagination justify-content-center">
                                <li className={'page-item' + (this.state.page === 0 ? ' disabled' : '')}>
                                    <a className="page-link" onClick={() => this.setPageNumber(0)}>
                                        {strings.first}
                                    </a>
                                </li>
                                {pagesArr.map(pageNumber => {
                                    if (this.state.page - 10 <= pageNumber && this.state.page + 10 >= pageNumber) {
                                        return (
                                            <li
                                                key={pageNumber}
                                                className={'page-item' + (this.state.page === pageNumber ? ' active' : '')}
                                            >
                                                <a className="page-link" onClick={() => this.setPageNumber(pageNumber)}>
                                                    {pageNumber + 1}
                                                </a>
                                            </li>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                                <li className={'page-item ' + (this.state.page === pagesArr.length - 1 ? 'disabled' : '')}>
                                    <a className="page-link" onClick={() => this.setPageNumber(pagesArr.length - 1)}>
                                        {strings.last}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    };

    componentDidUpdate(prevProps, prevState) {
        if (
            this.state.orderBy !== prevState.orderBy ||
            this.state.orderDirection !== prevState.orderDirection ||
            this.state.page !== prevState.page ||
            this.state.limit !== prevState.limit
        ) {
            this.generatePharmaciesList(this.state);
        }
    }

    componentDidMount() {
        this.generatePharmaciesList(this.state);
    }

    render() {
        return (
            <div className="container">
                <div className="row qf-mb-100">
                    <div className="col-1 light-blue-bg text-center pt-3">
                        <span className="qf-page-icon">{Svgs.pharmacy}</span>
                    </div>

                    <div className="col-11 white-bg px-5">
                        <div className="row">
                            <div className="col-9">
                                <h2 className="qf-page-title">
                                    <i className="fa fa-info-circle mr-2" />
                                    {strings.Pharmacies}
                                </h2>
                            </div>
                            <div className="col-3 align-self-center text-right">
                                <Link className="qf-blue-btn qf-mr-17p" to="/pharmacies/add-pharmacy">
                                    + {strings.Add_Pharmacy}
                                </Link>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <hr className="qf-divider-line" />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <table className="w-100 mb-3 qf-per-page-table">
                                    <tbody>
                                        <tr>
                                            <td />
                                            <td>
                                                <div className="formSelect">
                                                    <div className="selectWrapper">
                                                        <select value={this.state.limit} onChange={this.onLimitChange}>
                                                            <option value={10}>
                                                                {strings.formatString(strings.show_per_page, { num: 10 })}
                                                            </option>
                                                            <option value={20}>
                                                                {strings.formatString(strings.show_per_page, { num: 20 })}
                                                            </option>
                                                            <option value={30}>
                                                                {strings.formatString(strings.show_per_page, { num: 30 })}
                                                            </option>
                                                            <option value={40}>
                                                                {strings.formatString(strings.show_per_page, { num: 40 })}
                                                            </option>
                                                            <option value={50}>
                                                                {strings.formatString(strings.show_per_page, { num: 50 })}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </td>
                                            <td />
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <table className="qf-table qf-mb-30 qf-pharmacy-table">
                                    {this.generateTableHead()}
                                    {this.generateTableBody()}
                                </table>
                            </div>
                        </div>

                        {this.generatePagination()}
                    </div>
                </div>
            </div>
        );
    }
}

export default Pharmacies;



// WEBPACK FOOTER //
// ./src/customModules/Pharmacies/component-list-pharmacies.js